<template>
  <div class="vab-avatar">
    <span class="" v-if="isDashboard">
      <a href="/dashboard">展示大屏</a>
    </span>
    <a-dropdown trigger="click">
      <span class="ant-dropdown-link">
        <router-link to="/userProfile">
          <a-avatar :src="avatar" />
          {{ username }}
          <DownOutlined />
        </router-link>
      </span>
      <template v-slot:overlay>
        <a-menu>
          <a-menu-item @click="logout">退出登录</a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
  </div>
</template>

<script>
  import { DownOutlined } from '@ant-design/icons-vue'
  import { useStore } from 'vuex'
  import { computed } from 'vue'
  import { logout as logoutFn } from '../../utils/auth'

  export default {
    name: 'VabAvatar',
    components: { DownOutlined },
    setup() {
      const store = useStore()

      const logout = async () => {
        logoutFn(false)
      }

      return {
        avatar: computed(() => store.getters['user/avatar']),
        username: computed(() => store.getters['user/username']),
        isDashboard: computed(() => store.getters['user/isDashboard']),
        logout,
      }
    },
  }
</script>
<style lang="less">
  .vab-avatar {
    width: 100%;
    display: flex;
    justify-content: space-around;
    .ant-dropdown-link {
      display: block;
      min-height: 64px;
      cursor: pointer;
    }
  }
</style>
